window.casino = window.casino || {};
var repos = casino.repos = casino.repos || {};

casino.repos.igracDarkModeRepo = function (mode) {
    fetch('api/CasinoIgracDarkMode', {
        method: 'POST',
        credentials: repos.base.credentials,
        headers: repos.base.headers(),
        body: JSON.stringify(mode)
    })
        .then(casino.repos.base.checkResponse)
        .catch(casino.repos.base.handleNetworkException);
};